import { Filter, RefreshCw } from 'lucide-react';
import type { ButtonHTMLAttributes } from 'react';
import { cn } from '../ui/utils';
import { Button } from '../ui/Button';
import { useFilterBarLoading } from './filterBarContext';

type FilterSubmitButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> & {
    variant?: 'primary' | 'ghost' | 'danger';
    /** Exibe ícone RefreshCw quando não está em loading. */
    showRefreshIcon?: boolean;
    /** Exibe ícone Filter quando não está em loading. */
    showFilterIcon?: boolean;
};

/**
 * Botão submit padrão das barras de filtro Nexus.
 * Deve ser usado dentro de `FilterBar` para receber loading scoped ao submit.
 */
function FilterSubmitButton({
    variant = 'primary',
    showRefreshIcon = false,
    showFilterIcon = true,
    children = 'Filtrar',
    className,
    ...props
}: FilterSubmitButtonProps) {
    const loading = useFilterBarLoading();

    return (
        <Button
            type="submit"
            variant={variant}
            loading={loading}
            loadingText="Filtrando…"
            className={cn('!text-white', className)}
            {...props}
        >
            {!loading && showRefreshIcon ? <RefreshCw size={13} aria-hidden /> : null}
            {!loading && !showRefreshIcon && showFilterIcon ? <Filter size={13} aria-hidden /> : null}
            <span>{children}</span>
        </Button>
    );
}

export { FilterSubmitButton };

